var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2675 11.4333V19.8709C18.2675 20.2474 17.9625 20.5524 17.5859 20.5524H4.12828C3.75173 20.5524 3.4467 20.2474 3.4467 19.8709V11.4635C3.4467 11.2791 3.52166 11.1025 3.6535 10.9741L10.3866 4.44172C10.6512 4.1858 11.0708 4.18494 11.3353 4.44172L18.059 10.9439C18.1917 11.0723 18.2666 11.2489 18.2666 11.4342L18.2675 11.4333ZM0 10.5975V21.9191C0 23.0685 0.93147 24 2.08094 24H19.6332C20.7827 24 21.7142 23.0685 21.7142 21.9191V10.5656C21.7142 10.0021 21.485 9.46183 21.08 9.06977L12.3056 0.584862C11.4982 -0.195815 10.2169 -0.194953 9.41035 0.587447L0.631607 9.10424C0.227482 9.4963 0 10.0348 0 10.5975Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.877c786ab6dfddc34a4fb24e8acde161.svg";
export { ForwardRef as ReactComponent };